module.exports = __webpack_public_path__ + "static/media/vietnamese_team.798b953a.svg";